import { createQueryApi } from '@/shared/features/query/infra/adapters/rtk.adapter';
import type { ReduxQueryClient } from '@/shared/features/query/domain/interfaces/QueryClient';
import type { AppDispatch } from '@/app/store/store';
import type { PosRepository } from '../../domain/interfaces/PosRepository';
import type { PosApprovalModel } from '../../domain/models/PosApprovalModel';
import { adaptPosApprovalDtoToModel } from '../mappers/pos_approval_mapper';
import { PosApprovalActionDTO, PosApprovalDTO } from '../dto/pos_approval.dto';

const _posApprovalApi = createQueryApi({ clientId: 'posApprovalApi' });

const posApprovalRtkApi = _posApprovalApi.injectEndpoints({
  endpoints: (builder) => ({
    getApprovalData: builder.query<PosApprovalModel, string>({
      query: (code) => ({
        url: `/pcl/${code}`, 
        method: 'GET',
        withCredentials: true,
      }),
      providesTags: ['APPROVAL_DATA'],
      transformResponse: (rawResponse: { message: string | null; payload: PosApprovalDTO }) => {
        return rawResponse.payload;
      },
    }),
    submitApprovalAction: builder.mutation<void, PosApprovalActionDTO>({
      query: (payload) => ({
        url: `/pcl/action`,
        method: 'POST',
        data: payload, 
        withCredentials: true,
      }),
      invalidatesTags: ['APPROVAL_DATA']
    }),
  }),
});

export const posApprovalApiRedux = _posApprovalApi as unknown as ReduxQueryClient;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const hooks = posApprovalRtkApi as any;

export const useGetApprovalDataQuery = (
  arg: string , 
  options?: Record<string, unknown> 
) => hooks.useGetApprovalDataQuery(arg, options);

export class posApproval implements PosRepository {
  constructor(private readonly dispatch: AppDispatch) {}

  async getApprovalData(code: string): Promise<PosApprovalModel> {

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = await (this.dispatch as any)(
      posApprovalRtkApi.endpoints.getApprovalData.initiate(code)
    );
    
    if ('error' in result) {
      throw result.error;
    }
    
    return adaptPosApprovalDtoToModel(result.data as PosApprovalDTO);
  }

  async submitApprovalAction(aplrd: string, action: string): Promise<boolean> {

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = await (this.dispatch as any)(
      posApprovalRtkApi.endpoints.submitApprovalAction.initiate({ aplrd, action })
    );
    
    if ('error' in result) {
      throw result.error;
    }
    
    return true; 
  }
}